import { path } from 'ramda';

export const getUserRoles = path(['session', 'user', 'roles']);
